<div class="bordered_table table_withfilter">
  <table class="table table-responsive table-striped table-hover mb-0 merchtable">
    <colgroup>
      <col width="30">
      <col width="120">
      <col width="60">
      <col width="100">
      <col width="150">
      <col width="70">
      <col width="70">
    </colgroup>
    <thead>
      <tr>
        <th scope="col">&nbsp;</th>
        <th scope="col" class="text-left">Merchandise Item</th>
        <th scope="col" *ngIf="!moduleReservation" class="text-center">In Stock</th>
        <th scope="col" class="text-center" style="width: 100px;">Qty</th>
        <th scope="col" *ngIf="!moduleReservation">Discounts</th>
        <th scope="col" class="text-center">Price</th>
        <th scope="col" class="text-center">Tax</th>
      </tr>
      <tr>
        <th scope="col">&nbsp;</th>
        <th scope="col">
          <div class="unit_sel_box p-0">
            <input type="text" class="form-control form-control-sm" [(ngModel)]="filterMerchandiseName"
              (ngModelChange)="filterTable($event)">
            <button type="button" class="search_close"
              (click)="filterMerchandiseName=''; filterTable($event);"><span>×</span></button>
          </div>
        </th>
        <th scope="col" *ngIf="!moduleReservation" class="text-center">
          <div class="unit_sel_box p-0">
            <input type="text" class="form-control form-control-sm" [(ngModel)]="filterStock"
              (ngModelChange)="filterTable($event)">
            <button type="button" class="search_close" (click)="filterStock=''; filterTable($event);"><span
                aria-hidden="true">×</span></button>
          </div>
        </th>
        <th scope="col" class="text-center" style="width: 100px;">
          <div class="unit_sel_box p-0">
            <input type="text" class="form-control form-control-sm" [(ngModel)]="filterQty"
              (ngModelChange)="filterTable($event)">
            <button type="button" class="search_close" (click)="filterQty=''; filterTable($event);"><span
                aria-hidden="true">×</span></button>
          </div>
        </th>
        <th scope="col" *ngIf="!moduleReservation">
          <div class="unit_sel_box p-0">
            <input type="text" class="form-control form-control-sm" [(ngModel)]="filterDiscount"
              (ngModelChange)="filterTable($event)">
            <button type="button" class="search_close" (click)="filterDiscount=''; filterTable($event);"><span
                aria-hidden="true">×</span></button>
          </div>
        </th>
        <th scope="col" class="text-center">
          <div class="unit_sel_box p-0">
            <input type="text" class="form-control form-control-sm" [(ngModel)]="filterPrice"
              (ngModelChange)="filterTable($event)">
            <button type="button" class="search_close" (click)="filterPrice=''; filterTable($event);"><span
                aria-hidden="true">×</span></button>
          </div>
        </th>
        <th scope="col" class="text-center"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of MerchandiseList">
        <td scope="col" class="text-center align-middle">
          <label class="pure-material-checkbox mb-0 without-text">
            <input type="checkbox" class="custom-control-input" [(ngModel)]="item.selected"
              (ngModelChange)="merchandiseSelect($event,item.Id, item.MerchandiseType)" [disabled]="item.isDefaultLocked">
            <span></span>
          </label>
        </td>
        <td scope="col" class="align-middle">{{item.Name}}</td>
        <td scope="col" *ngIf="!moduleReservation" class="align-middle text-center">{{item.InStock}}</td>
        <td scope="col" class="text-center">
          <div class="d-flex">
            <button class="btn btn-primary qty_squre btn-sm" (click)="removeQuantity(item.Id, item.Code )"
              [disabled]="!item.selected || item.isDefaultLocked">
              <i class="fas fa-minus"></i></button>
            <input type="text" min="0" class="float-left form-control span_width_70 mx-2 form-control-sm text-center"
              [disabled]="!item.selected || item.isDefaultLocked" (keypress)="numberOnly($event)" [(ngModel)]="item.Quantity"
              (keyup)="quantityChange($event.target.value,item.Id, item.Code )" />
            <button class="btn btn-primary qty_squre btn-sm" (click)="addQuantity(item.Id, item.Code )"
              [disabled]="!item.selected || item.isDefaultLocked">
              <i class="fas fa-plus"></i></button>
          </div>
        </td>
        <td scope="col" *ngIf="!moduleReservation">
          <div class="d-flex" style="gap: 5px;">
            <input type="text" class="form-control mr-2 form-control-sm" [value]="item.DiscountName"
              [title]="item.DiscountName" readonly>
            <button class="btn btn-primary btn-sm" 
              [disabled]="!item.selected" 
              (click)="populateDiscountPopup(item.Id,item.MerchandiseType)"><i class="fa fa-pencil"></i></button>
          </div>
        </td>
        <td scope="col" class="align-middle text-center">{{item.TenantPrice | currency}}</td>
        <td scope="col" class="align-middle text-center">{{item.TenantPiceTax | currency}}</td>
      </tr>
      <tr *ngIf="MerchandiseList.length == 0">
        <td colspan="7">No data Available</td>
      </tr>

    </tbody>
  </table>
</div>


<!-- Pricing and Promotions Modal -->
<ng-template #discountModalPopup>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Pricing and Promotions</h5>
      <button type="button" class="close" (click)="modalRef.hide()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <label class="pure-material-checkbox mt-3 d-block" *ngFor="let item of merchandiseDiscountList">
        <input type="checkbox" class="checkBoxClass" [(ngModel)]="item.Selected" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="discpopCheckChange()" [disabled]="item.isDefaultLocked">
        <span>{{ item.Name }}</span>
      </label>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary mr-3" (click)="cancelDiscount()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="applyDiscount()"
        [disabled]="priproCheckSaveDisable">Save</button>
    </div>
  </div>
</ng-template>
<!-- // End Pricing and Promotions Modal -->
